import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AbstractRedlineService, DataCollectionService, OverlayService } from '@finra/rampdi-forms-common';

@Injectable({
  providedIn: 'root',
})
export class RedlineService extends AbstractRedlineService {
  private currentTitle: string = 'View All Changes';

  constructor(
    public route: ActivatedRoute,
    private DCS: DataCollectionService,
    private OS: OverlayService,
  ) {
    super(route, DCS, OS);
  }

  classifyDiffData(instanceData, navData, sourceVersion?) {
    const result = {
      type: 'redline',
      title: this.currentTitle, // Use dynamic title
      open: true,
      errors: true,
      chips: [],
      get selectedTypes() {
        return this.chips.filter((chip) => chip.selected).map((chip) => chip.type);
      },
      get count() {
        return this.sections.find((section) => section.id === 'all')?.items?.filter((item) => !item.hide).length;
      },
    };
    return result;
  }
}
